/**
 * A yes/no preference kept per browser in localStorage.
 *
 * Used for reviewer-pace switches that are not customer content and must
 * not follow the team: the ask panel's run-on-open (TRA-1081), and the
 * folded nav and review queue (TRA-1085). Blocked storage means the
 * preference simply does not stick, which is the right outcome for a
 * convenience switch; `lib/storedValue.ts` does the guarding.
 */

import { readStoredValue, writeStoredValue, type ValueStorage } from '@/lib/storedValue'

/** `'true'` / `'false'` as written by `writeStoredFlag`; anything else is the fallback. */
export function parseStoredFlag(raw: string | null, fallback: boolean): boolean {
  if (raw === 'true') return true
  if (raw === 'false') return false
  return fallback
}

/** `storage` is injected by the tests (vitest runs without a window). */
export function readStoredFlag(
  key: string,
  fallback: boolean,
  storage?: ValueStorage,
): boolean {
  return parseStoredFlag(readStoredValue(key, storage), fallback)
}

export function writeStoredFlag(
  key: string,
  value: boolean,
  storage?: ValueStorage,
): void {
  writeStoredValue(key, value ? 'true' : 'false', storage)
}
